export const updateSecondaryScrollPercent = (percent, modules) => ({
  type: "UPDATE_SECONDARY_SCROLL_PERCENT",
  percent,
  modules
});
